<h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>
<div mat-dialog-content *ngIf="data.content">{{ data.content }}</div>

<ng-container [ngSwitch]="data.type">
  <div *ngSwitchCase="'progress'" mat-dialog-actions>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngSwitchCase="'error'" mat-dialog-actions>
    <ub-button-list>
      <button mat-flat-button
              color="primary"
              [mat-dialog-close]="false"
              cdkFocusInitial>{{ data.okButton }}</button>
    </ub-button-list>
  </div>

  <div *ngSwitchDefault mat-dialog-actions>
    <ub-button-list>
      <button mat-flat-button
              color="{{data.okButtonColor}}"
              [mat-dialog-close]="true"
              cdkFocusInitial>{{ data.okButton }}</button>
      <button mat-flat-button
              color="{{data.cancelButtonColor}}"
              [mat-dialog-close]="canceled">{{ data.cancelButton }}</button>
    </ub-button-list>
  </div>

</ng-container>
